export enum Vendors{
    Afaqy = 'AFAQY',
}